import partnerships_trend_micro from './partnerships-trend-micro.svg';

export const V2_PARTNERSHIPS_ICONS: { [char: string]: string } = {
  partnerships_trend_micro,
};

export const V2_PARTNERSHIPS_ICON_NAMES: string[] = Object.keys(V2_PARTNERSHIPS_ICONS);
